import { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next'

// import Loader from '~components/Loader/Loader';
import Loader from '../Loader/Loader';

import { useHookStore } from '../../hook-store/store';
import { 
  cardExpire,
  updateSubscriptionDefaultPaymentMethod,
  detachPaymentMethod,
 } from '../../utils/stripe/payment-method-utils';
import { 
  getCustomerSubscriptions,
} from '../../utils/stripe/usage-based-billing-utils';

// import { 
//   BACKEND_URL,  
// } from '~config/endpoints';
import {
  IMAGEPHOTO_BACKENDURL
} from '../../lib/api';

import classes from './PaymentMethods.module.css';

function PaymentMethodsItem(props) {

  const {
    method,
    cardInfo,
    isSubscriptionMethod,
    cardExpired,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useHookStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
    customerMethods,
    usageBasedValidMethod,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [showConfirmDetach, setShowConfirmDetach] = useState(false);
  

  const updateSubscriptionMethodHandler = async (subscriptionId, paymentMethodId) => {
    try {
      setIsLoading(true);
      // setError('');

      const resData = await updateSubscriptionDefaultPaymentMethod(
        IMAGEPHOTO_BACKENDURL, 
        localStorage.getItem('token'),
        localStorage.getItem('customerId'),
        subscriptionId,
        paymentMethodId,
      );

      // console.log(resData);

      if (resData.data 
        // && resData.data.default_payment_method === paymentMethodId
      ) {
        
        dispatch('SET_USAGEBASEDSUBSCRIPTION', resData.data);
      }

      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };


  const detachMethodHandler = async (paymentMethodId) => {
    try {
      setIsLoading(true);
      // setError('');

      const resData = await detachPaymentMethod(
        IMAGEPHOTO_BACKENDURL, 
        localStorage.getItem('token'),
        localStorage.getItem('customerId'),
        paymentMethodId,
      );

      // console.log(resData);

      if (resData.data) {
        const deletedList = customerMethods.filter(method => {
          return method.id !== paymentMethodId;
        });

        dispatch('SET_CUSTOMERMETHODS', deletedList);

        if (usageBasedSubscription && 
            usageBasedSubscription.default_payment_method === paymentMethodId
        ) {
            getUsageBasedSubscription();
          }
      }

      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  const getUsageBasedSubscription = async () => {
    try {
      const customerId = localStorage.getItem('customerId');

      const resData = await getCustomerSubscriptions(
        IMAGEPHOTO_BACKENDURL,
        localStorage.getItem('token'),
        customerId,
      )
      
      // console.log('usage based subscription', result, resData);
      
      if (resData?.data) {
        const usageBasedSubscription = resData.data.find(ele => {
          return ele.plan.id === usageBasedPrice.id
        });
        // console.log('usage based subscription', usageBasedSubscription);
        if (usageBasedSubscription) {
          dispatch('SET_USAGEBASEDSUBSCRIPTION', usageBasedSubscription);
        }

      }

      return resData;

    } catch(err) {
      console.log(err);
      throw err;
    }
  };




  let paymentMethodsItemBody

  paymentMethodsItemBody = (
    <div className={classes.paymentMethodsItem}>
      {/* {method.id} */}
      <div className={classes.paymentMethodsItemRow}>
        {t('usageBased11', 'Card last 4-digit')}:{' '}
        <strong>{cardInfo.last4}</strong>
      </div>
      <div className={classes.paymentMethodsItemRow}>
        {t('usageBased12', 'Card expiration date')}:{' '}
        <strong>
          {cardInfo.exp_month}/{cardInfo.exp_year}
        </strong>
      </div>
      <div className={classes.paymentMethodsItemRow}>
        ({t('usageBased13', 'add date')} {new Date(method.created*1000).toLocaleDateString()})
      </div>
      {isSubscriptionMethod && usageBasedValidMethod && (
        <div className={classes.paymentMethodsItemRow}>
          <strong>
            {t('usageBased14', 'Payment method')}
          </strong>
            {/* <button
              disabled={isLoading}
              onClick={() => {
                updateSubscriptionMethodHandler(
                  usageBasedSubscription.id,
                  '',
                );
              }}
            >
            delete-from-sub
          </button> */}
        </div>
      )}
      {!isSubscriptionMethod && !cardExpired && (
        <div className={classes.paymentMethodsItemRow}>
          <button className='btnBase'
            disabled={isLoading}
            onClick={() => {
              updateSubscriptionMethodHandler(
                usageBasedSubscription.id,
                method.id,
              );
            }}
          >
            {t('usageBased15', 'Select this card')}
          </button>
        </div>
      )}
      {cardExpired && (
        <div className={classes.paymentMethodsItemRow}>
          {t('usageBased16', 'Expired card')}
        </div>
      )}

      {/* <div>
        <button
          disabled={isLoading}
          onClick={() => {
            setShowConfirmDetach(!showConfirmDetach);
            setSelectedId(method.id);
          }}
        >
          delete-this-method
        </button>
      </div>
      {showConfirmDetach && selectedId === method.id && (
        <div>
          <div>
            delete-this-method?
          </div>
          <button
            disabled={isLoading}
            onClick={() => {
              setShowConfirmDetach(!showConfirmDetach);
            }}
          >
            cancel-detach
          </button>
          <button
            disabled={isLoading}
            onClick={() => {
              detachMethodHandler(method.id);
            }}
          >
            delete-this-method
          </button>
        </div>
      )} */}

      {isLoading && (
        <Loader />
      )}

    </div>
  );



  return (
    <Fragment>
      <div>
        {paymentMethodsItemBody}
      </div>
    </Fragment>
  );
}

export default PaymentMethodsItem;
